import { createFileRoute, notFound } from "@tanstack/react-router";
import { helpSearch } from "../../src/lib/help-navigation";
import { helpHead } from "../lib/help-route";
import { loadHelpIndex } from "../platform/help";
import { HelpHome } from "../platform/help/help-pages";

export const Route = createFileRoute("/help/topics/$slug")({
  validateSearch: helpSearch,
  loaderDeps: ({ search }) => search,
  loader: async ({ params, deps }) => {
    const page = await loadHelpIndex({ data: { ...deps, slug: params.slug } });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) => helpHead(matches, loaderData),
  component: () => <HelpHome page={Route.useLoaderData()} />,
});
